// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  PostApiUserChangePasswordData,
  PostApiUserChangePasswordResponse,
  PutApiUserData,
  PutApiUserResponse,
  DeleteApiUserData,
  DeleteApiUserResponse,
  PostApiUserData,
  PostApiUserResponse,
  PutApiUserSimpleData,
  PutApiUserSimpleResponse,
  GetApiUserExistsByEmailData,
  GetApiUserExistsByEmailResponse,
  PostApiUserForgotPasswordData,
  PostApiUserForgotPasswordResponse,
  GetApiUserByIdData,
  GetApiUserByIdResponse,
  GetApiUserResponse,
  GetApiUserRolesResponse,
  PostApiUserResetPasswordData,
  PostApiUserResetPasswordResponse,
  GetApiUserResetByIdData,
  GetApiUserResetByIdResponse,
  PostApiUserPasswordData,
  PostApiUserPasswordResponse,
  PostApiUserOptionData,
  PostApiUserOptionResponse,
  PostApiUserLocationCreateData,
  PostApiUserLocationCreateResponse,
  PostApiTokenData,
  PostApiTokenResponse,
  PostApiTokenSetLocationData,
  PostApiTokenSetLocationResponse,
  PostApiTokenSetTenantData,
  PostApiTokenSetTenantResponse,
  PostApiTenantActivateData,
  PostApiTenantActivateResponse,
  PutApiTenantAdminCreateData,
  PutApiTenantAdminCreateResponse,
  PutApiTenantData,
  PutApiTenantResponse,
  GetApiTenantResponse,
  GetApiTenantExistsByCompanyData,
  GetApiTenantExistsByCompanyResponse,
  GetApiTenantFinanceResponse,
  GetApiTenantByCompanyData,
  GetApiTenantByCompanyResponse,
  GetApiTenantPrefillData,
  GetApiTenantPrefillResponse,
  GetApiTenantStatsResponse,
  PostApiTenantInvitationsAcceptData,
  PostApiTenantInvitationsAcceptResponse,
  GetApiTenantInvitationByIdData,
  GetApiTenantInvitationByIdResponse,
  PostApiTenantInvitationsData,
  PostApiTenantInvitationsResponse,
  GetApiTenantInvitationsResponse,
  PostApiTenantInvitationsResendData,
  PostApiTenantInvitationsResendResponse,
  PostApiTenantInvitationsRevokeData,
  PostApiTenantInvitationsRevokeResponse,
  GetApiSubscriptionTypesGetAllResponse,
  PostApiSubscriptionTypesUpdateData,
  PostApiSubscriptionTypesUpdateResponse,
  PostApiSubscriptionsActivateResponse,
  PostApiSubscriptionsCancelData,
  PostApiSubscriptionsCancelResponse,
  PostApiSubscriptionsCreateData,
  PostApiSubscriptionsCreateResponse,
  GetApiSubscriptionsResponse,
  PostApiSubscriptionsRestoreResponse,
  PostApiSubscriptionsUpdatetrialData,
  PostApiSubscriptionsUpdatetrialResponse,
  GetApiSettingsResponse,
  PostApiSettingsData,
  PostApiSettingsResponse,
  GetApiReportsByIdData,
  GetApiReportsByIdResponse,
  GetApiReportsDailyCheckReportData,
  GetApiReportsDailyCheckReportResponse,
  GetApiPublicStatsResponse,
  PostApiPaymentCancelResponse,
  PostApiPaymentCreateData,
  PostApiPaymentCreateResponse,
  PostApiPaymentCreateinvoiceData,
  PostApiPaymentCreateinvoiceResponse,
  GetApiPaymentInvoiceData,
  GetApiPaymentInvoiceResponse,
  PostApiPaymentHistoryData,
  PostApiPaymentHistoryResponse,
  GetApiPaymentStatusData,
  GetApiPaymentStatusResponse,
  PutApiPaymentUpdateData,
  PutApiPaymentUpdateResponse,
  PostApiPaymentUpdatepaymentmethodResponse,
  PostApiPaymentWebhookStripeResponse,
  PostApiPaymentWebhookXeroResponse,
  GetApiXeroAuthResponse,
  GetApiXeroCallbackData,
  GetApiXeroCallbackResponse,
  DeleteApiNotificationsByIdData,
  DeleteApiNotificationsByIdResponse,
  GetApiNotificationsListResponse,
  PostApiNotificationsSetAsSeenResponse,
  PostApiNotificationsData,
  PostApiNotificationsResponse,
  GetApiMailByIdEventsData,
  GetApiMailByIdEventsResponse,
  PostApiMailListRecentData,
  PostApiMailListRecentResponse,
  PostApiMailWebhookSendgridResponse,
  PostApiLocationCloneData,
  PostApiLocationCloneResponse,
  PostApiLocationCreateData,
  PostApiLocationCreateResponse,
  DeleteApiLocationByIdData,
  DeleteApiLocationByIdResponse,
  GetApiLocationExsistsByIdData,
  GetApiLocationExsistsByIdResponse,
  GetApiLocationExportByIdData,
  GetApiLocationExportByIdResponse,
  GetApiLocationGetAllResponse,
  GetApiLocationGetByIdData,
  GetApiLocationGetByIdResponse,
  GetApiLocationResponse,
  PostApiLocationUpdateData,
  PostApiLocationUpdateResponse,
  PostApiIssueCommentData,
  PostApiIssueCommentResponse,
  PostApiIssueCreateData,
  PostApiIssueCreateResponse,
  PostApiIssueDeleteAttachmentData,
  PostApiIssueDeleteAttachmentResponse,
  PostApiIssueGetData,
  PostApiIssueGetResponse,
  PostApiIssueListData,
  PostApiIssueListResponse,
  PostApiIssueListAllData,
  PostApiIssueListAllResponse,
  PostApiIssuePreUploadAttachmentResponse,
  PostApiIssueSendEmailData,
  PostApiIssueSendEmailResponse,
  PostApiIssueAcceptedData,
  PostApiIssueAcceptedResponse,
  PostApiIssueSetCategoryData,
  PostApiIssueSetCategoryResponse,
  PostApiIssueSeenData,
  PostApiIssueSeenResponse,
  PostApiIssueUploadAttachmentData,
  PostApiIssueUploadAttachmentResponse,
  PostApiIssueCategoriesCreateData,
  PostApiIssueCategoriesCreateResponse,
  DeleteApiIssueCategoriesDeleteByIdData,
  DeleteApiIssueCategoriesDeleteByIdResponse,
  GetApiIssueCategoriesListResponse,
  PutApiIssueCategoriesUpdateData,
  PutApiIssueCategoriesUpdateResponse,
  PostApiEmailContactsCreateData,
  PostApiEmailContactsCreateResponse,
  DeleteApiEmailContactsDeleteByIdData,
  DeleteApiEmailContactsDeleteByIdResponse,
  GetApiEmailContactsListResponse,
  PutApiEmailContactsUpdateData,
  PutApiEmailContactsUpdateResponse,
  DeleteApiDocumentsByIdData,
  DeleteApiDocumentsByIdResponse,
  GetApiDocumentsDownloadData,
  GetApiDocumentsDownloadResponse,
  GetApiDocumentsFoldersResponse,
  GetApiDocumentsListData,
  GetApiDocumentsListResponse,
  GetApiDocumentsMoveData,
  GetApiDocumentsMoveResponse,
  PostApiDocumentsUploadData,
  PostApiDocumentsUploadResponse,
  GetApiDocumentsViewData,
  GetApiDocumentsViewResponse,
  PostApiTestEmailallData,
  PostApiTestEmailallResponse,
  PostApiTestEmailtenantData,
  PostApiTestEmailtenantResponse,
  PostApiTestQueryData,
  PostApiTestQueryResponse,
  PostApiTestEmailData,
  PostApiTestEmailResponse,
  PostApiDeviceCreateData,
  PostApiDeviceCreateResponse,
  DeleteApiDeviceDeleteByIdData,
  DeleteApiDeviceDeleteByIdResponse,
  GetApiDeviceByIdData,
  GetApiDeviceByIdResponse,
  PostApiDeviceListData,
  PostApiDeviceListResponse,
  PostApiDeviceData,
  PostApiDeviceResponse,
  GetApiDashboardData,
  GetApiDashboardResponse,
  PostApiDashboardLocationData,
  PostApiDashboardLocationResponse,
  GetApiCompletedchecksByIdData,
  GetApiCompletedchecksByIdResponse,
  GetApiCompletedchecksBydateData,
  GetApiCompletedchecksBydateResponse,
  PostApiCompletedchecksListAllData,
  PostApiCompletedchecksListAllResponse,
  PostApiCompletedchecksSaveData,
  PostApiCompletedchecksSaveResponse,
  PostApiCompletedchecksSaveretroactiveData,
  PostApiCompletedchecksSaveretroactiveResponse,
  GetApiCompletedChecksImageData,
  GetApiCompletedChecksImageResponse,
  GetApiTasksListByCheckIdData,
  GetApiTasksListByCheckIdResponse,
  GetApiCheckCalendarData,
  GetApiCheckCalendarResponse,
  PostApiCheckCloneData,
  PostApiCheckCloneResponse,
  PutApiCheckData,
  PutApiCheckResponse,
  PostApiCheckData,
  PostApiCheckResponse,
  DeleteApiCheckByIdData,
  DeleteApiCheckByIdResponse,
  GetApiCheckByIdData,
  GetApiCheckByIdResponse,
  GetApiCheckExportResponse,
  PutApiCheckImportData,
  PutApiCheckImportResponse,
  PostApiCheckListData,
  PostApiCheckListResponse,
  GetApiCheckListTodaysResponse,
  PostApiCheckOrderData,
  PostApiCheckOrderResponse,
  GetApiChatbaseResponse,
} from "./types.gen";

export class UserService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiUserChangePassword(
    data: PostApiUserChangePasswordData,
  ): CancelablePromise<PostApiUserChangePasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/change-password",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserDto Success
   * @throws ApiError
   */
  public static putApiUser(
    data: PutApiUserData,
  ): CancelablePromise<PutApiUserResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserDto Success
   * @throws ApiError
   */
  public static deleteApiUser(
    data: DeleteApiUserData,
  ): CancelablePromise<DeleteApiUserResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/user",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiUser(
    data: PostApiUserData,
  ): CancelablePromise<PostApiUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserDto Success
   * @throws ApiError
   */
  public static putApiUserSimple(
    data: PutApiUserSimpleData,
  ): CancelablePromise<PutApiUserSimpleResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/user/simple",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.email
   * @returns boolean Success
   * @throws ApiError
   */
  public static getApiUserExistsByEmail(
    data: GetApiUserExistsByEmailData,
  ): CancelablePromise<GetApiUserExistsByEmailResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/exists/{email}",
      path: {
        email: data.email,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiUserForgotPassword(
    data: PostApiUserForgotPasswordData,
  ): CancelablePromise<PostApiUserForgotPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/forgot-password",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UserDto Success
   * @throws ApiError
   */
  public static getApiUserById(
    data: GetApiUserByIdData,
  ): CancelablePromise<GetApiUserByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns UserDto Success
   * @throws ApiError
   */
  public static getApiUser(): CancelablePromise<GetApiUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns RoleDto Success
   * @throws ApiError
   */
  public static getApiUserRoles(): CancelablePromise<GetApiUserRolesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/roles",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiUserResetPassword(
    data: PostApiUserResetPasswordData,
  ): CancelablePromise<PostApiUserResetPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/reset-password",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UserDto Success
   * @throws ApiError
   */
  public static getApiUserResetById(
    data: GetApiUserResetByIdData,
  ): CancelablePromise<GetApiUserResetByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user/reset/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiUserPassword(
    data: PostApiUserPasswordData,
  ): CancelablePromise<PostApiUserPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/password",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiUserOption(
    data: PostApiUserOptionData,
  ): CancelablePromise<PostApiUserOptionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/user/option",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class UserlocationService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserLocationDto Success
   * @throws ApiError
   */
  public static postApiUserLocationCreate(
    data: PostApiUserLocationCreateData,
  ): CancelablePromise<PostApiUserLocationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/userLocation/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class TokenService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TokenResponse Success
   * @throws ApiError
   */
  public static postApiToken(
    data: PostApiTokenData,
  ): CancelablePromise<PostApiTokenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/token",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TokenResponse Success
   * @throws ApiError
   */
  public static postApiTokenSetLocation(
    data: PostApiTokenSetLocationData,
  ): CancelablePromise<PostApiTokenSetLocationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/token/set-location/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TokenResponse Success
   * @throws ApiError
   */
  public static postApiTokenSetTenant(
    data: PostApiTokenSetTenantData,
  ): CancelablePromise<PostApiTokenSetTenantResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/token/set-tenant/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class TenantService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TenantActivationResponseDto Success
   * @throws ApiError
   */
  public static postApiTenantActivate(
    data: PostApiTenantActivateData,
  ): CancelablePromise<PostApiTenantActivateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tenant/activate",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TenantActivationResponseDto Success
   * @throws ApiError
   */
  public static putApiTenantAdminCreate(
    data: PutApiTenantAdminCreateData,
  ): CancelablePromise<PutApiTenantAdminCreateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/tenant/admin-create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserDto Success
   * @throws ApiError
   */
  public static putApiTenant(
    data: PutApiTenantData,
  ): CancelablePromise<PutApiTenantResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/tenant",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns TenantDto Success
   * @throws ApiError
   */
  public static getApiTenant(): CancelablePromise<GetApiTenantResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns boolean Success
   * @throws ApiError
   */
  public static getApiTenantExistsByCompany(
    data: GetApiTenantExistsByCompanyData,
  ): CancelablePromise<GetApiTenantExistsByCompanyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/exists/{company}",
      path: {
        company: data.company,
      },
    });
  }

  /**
   * @returns TenantStatistic Success
   * @throws ApiError
   */
  public static getApiTenantFinance(): CancelablePromise<GetApiTenantFinanceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/finance",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns Tenant Success
   * @throws ApiError
   */
  public static getApiTenantByCompany(
    data: GetApiTenantByCompanyData,
  ): CancelablePromise<GetApiTenantByCompanyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/{company}",
      path: {
        company: data.company,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.from
   * @param data.to
   * @returns TenantActivationResponseDto Success
   * @throws ApiError
   */
  public static getApiTenantPrefill(
    data: GetApiTenantPrefillData,
  ): CancelablePromise<GetApiTenantPrefillResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/prefill",
      query: {
        from: data.from,
        to: data.to,
      },
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @returns TenantStatistic Success
   * @throws ApiError
   */
  public static getApiTenantStats(): CancelablePromise<GetApiTenantStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/stats",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AcceptInviteResponse Success
   * @throws ApiError
   */
  public static postApiTenantInvitationsAccept(
    data: PostApiTenantInvitationsAcceptData,
  ): CancelablePromise<PostApiTenantInvitationsAcceptResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tenant/invitations/accept",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns InvitationStatusResponse Success
   * @throws ApiError
   */
  public static getApiTenantInvitationById(
    data: GetApiTenantInvitationByIdData,
  ): CancelablePromise<GetApiTenantInvitationByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/invitation/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns InviteUserResponse Success
   * @throws ApiError
   */
  public static postApiTenantInvitations(
    data: PostApiTenantInvitationsData,
  ): CancelablePromise<PostApiTenantInvitationsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tenant/invitations",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns TenantInvitation Success
   * @throws ApiError
   */
  public static getApiTenantInvitations(): CancelablePromise<GetApiTenantInvitationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tenant/invitations",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiTenantInvitationsResend(
    data: PostApiTenantInvitationsResendData,
  ): CancelablePromise<PostApiTenantInvitationsResendResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tenant/invitations/resend",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiTenantInvitationsRevoke(
    data: PostApiTenantInvitationsRevokeData,
  ): CancelablePromise<PostApiTenantInvitationsRevokeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tenant/invitations/revoke",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class SubscriptiontypesService {
  /**
   * @returns SubscriptionTypeDto Success
   * @throws ApiError
   */
  public static getApiSubscriptionTypesGetAll(): CancelablePromise<GetApiSubscriptionTypesGetAllResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/subscriptionTypes/get/all",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SubscriptionTypeDto Success
   * @throws ApiError
   */
  public static postApiSubscriptionTypesUpdate(
    data: PostApiSubscriptionTypesUpdateData,
  ): CancelablePromise<PostApiSubscriptionTypesUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/subscriptionTypes/update",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class SubscriptionsService {
  /**
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiSubscriptionsActivate(): CancelablePromise<PostApiSubscriptionsActivateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/subscriptions/activate",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiSubscriptionsCancel(
    data: PostApiSubscriptionsCancelData,
  ): CancelablePromise<PostApiSubscriptionsCancelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/subscriptions/cancel",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SubscriptionDto Success
   * @throws ApiError
   */
  public static postApiSubscriptionsCreate(
    data: PostApiSubscriptionsCreateData,
  ): CancelablePromise<PostApiSubscriptionsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/subscriptions/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns SubscriptionDto Success
   * @throws ApiError
   */
  public static getApiSubscriptions(): CancelablePromise<GetApiSubscriptionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/subscriptions/",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiSubscriptionsRestore(): CancelablePromise<PostApiSubscriptionsRestoreResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/subscriptions/restore",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SubscriptionDto Success
   * @throws ApiError
   */
  public static postApiSubscriptionsUpdatetrial(
    data: PostApiSubscriptionsUpdatetrialData,
  ): CancelablePromise<PostApiSubscriptionsUpdatetrialResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/subscriptions/updatetrial",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }
}

export class SettingsService {
  /**
   * @returns SettingDto Success
   * @throws ApiError
   */
  public static getApiSettings(): CancelablePromise<GetApiSettingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/settings",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SettingDto Success
   * @throws ApiError
   */
  public static postApiSettings(
    data: PostApiSettingsData,
  ): CancelablePromise<PostApiSettingsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/settings",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class ReportsService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.filename
   * @returns unknown Success
   * @throws ApiError
   */
  public static getApiReportsById(
    data: GetApiReportsByIdData,
  ): CancelablePromise<GetApiReportsByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/reports/{id}",
      path: {
        id: data.id,
      },
      query: {
        filename: data.filename,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.from
   * @param data.to
   * @param data.checkIds
   * @returns string Success
   * @throws ApiError
   */
  public static getApiReportsDailyCheckReport(
    data: GetApiReportsDailyCheckReportData,
  ): CancelablePromise<GetApiReportsDailyCheckReportResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/reports/DailyCheckReport",
      query: {
        from: data.from,
        to: data.to,
        checkIds: data.checkIds,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class PublicService {
  /**
   * @returns MarketingStatsDto Success
   * @throws ApiError
   */
  public static getApiPublicStats(): CancelablePromise<GetApiPublicStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/public/stats",
    });
  }
}

export class PaymentService {
  /**
   * @returns PaymentSession Success
   * @throws ApiError
   */
  public static postApiPaymentCancel(): CancelablePromise<PostApiPaymentCancelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/cancel",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PaymentSession Success
   * @throws ApiError
   */
  public static postApiPaymentCreate(
    data: PostApiPaymentCreateData,
  ): CancelablePromise<PostApiPaymentCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiPaymentCreateinvoice(
    data: PostApiPaymentCreateinvoiceData,
  ): CancelablePromise<PostApiPaymentCreateinvoiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/createinvoice",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Success
   * @throws ApiError
   */
  public static getApiPaymentInvoice(
    data: GetApiPaymentInvoiceData = {},
  ): CancelablePromise<GetApiPaymentInvoiceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/payment/invoice",
      query: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PagedResultOfPaymentHistoryDto Success
   * @throws ApiError
   */
  public static postApiPaymentHistory(
    data: PostApiPaymentHistoryData,
  ): CancelablePromise<PostApiPaymentHistoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/history",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns PaymentSessionStatus Success
   * @throws ApiError
   */
  public static getApiPaymentStatus(
    data: GetApiPaymentStatusData,
  ): CancelablePromise<GetApiPaymentStatusResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/payment/status",
      query: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiPaymentUpdate(
    data: PutApiPaymentUpdateData,
  ): CancelablePromise<PutApiPaymentUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/payment/update",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static postApiPaymentUpdatepaymentmethod(): CancelablePromise<PostApiPaymentUpdatepaymentmethodResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/updatepaymentmethod",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiPaymentWebhookStripe(): CancelablePromise<PostApiPaymentWebhookStripeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/webhook/stripe",
    });
  }

  /**
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiPaymentWebhookXero(): CancelablePromise<PostApiPaymentWebhookXeroResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/payment/webhook/xero",
    });
  }
}

export class XeroService {
  /**
   * @returns unknown Success
   * @throws ApiError
   */
  public static getApiXeroAuth(): CancelablePromise<GetApiXeroAuthResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/xero/auth",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.code
   * @param data.state
   * @returns SettingDto Success
   * @throws ApiError
   */
  public static getApiXeroCallback(
    data: GetApiXeroCallbackData,
  ): CancelablePromise<GetApiXeroCallbackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/xero/callback",
      query: {
        code: data.code,
        state: data.state,
      },
    });
  }
}

export class NotificationsService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns NotificationDto Success
   * @throws ApiError
   */
  public static deleteApiNotificationsById(
    data: DeleteApiNotificationsByIdData,
  ): CancelablePromise<DeleteApiNotificationsByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/notifications/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns NotificationDto Success
   * @throws ApiError
   */
  public static getApiNotificationsList(): CancelablePromise<GetApiNotificationsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/notifications/list",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiNotificationsSetAsSeen(): CancelablePromise<PostApiNotificationsSetAsSeenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notifications/setAsSeen",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns NotificationDto Success
   * @throws ApiError
   */
  public static postApiNotifications(
    data: PostApiNotificationsData,
  ): CancelablePromise<PostApiNotificationsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/notifications",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class MailService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns MailEventDto Success
   * @throws ApiError
   */
  public static getApiMailByIdEvents(
    data: GetApiMailByIdEventsData,
  ): CancelablePromise<GetApiMailByIdEventsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/mail/{id}/events",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PagedResultOfMailActivityDto Success
   * @throws ApiError
   */
  public static postApiMailListRecent(
    data: PostApiMailListRecentData,
  ): CancelablePromise<PostApiMailListRecentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mail/list-recent",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiMailWebhookSendgrid(): CancelablePromise<PostApiMailWebhookSendgridResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/mail/webhook/sendgrid",
    });
  }
}

export class LocationService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LocationDto Success
   * @throws ApiError
   */
  public static postApiLocationClone(
    data: PostApiLocationCloneData,
  ): CancelablePromise<PostApiLocationCloneResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/location/clone",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LocationDto Success
   * @throws ApiError
   */
  public static postApiLocationCreate(
    data: PostApiLocationCreateData,
  ): CancelablePromise<PostApiLocationCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/location/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteApiLocationById(
    data: DeleteApiLocationByIdData,
  ): CancelablePromise<DeleteApiLocationByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/location/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean Success
   * @throws ApiError
   */
  public static getApiLocationExsistsById(
    data: GetApiLocationExsistsByIdData,
  ): CancelablePromise<GetApiLocationExsistsByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/location/exsists/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns string Success
   * @throws ApiError
   */
  public static getApiLocationExportById(
    data: GetApiLocationExportByIdData,
  ): CancelablePromise<GetApiLocationExportByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/location/export/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns LocationDto Success
   * @throws ApiError
   */
  public static getApiLocationGetAll(): CancelablePromise<GetApiLocationGetAllResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/location/get/all",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns LocationDto Success
   * @throws ApiError
   */
  public static getApiLocationGetById(
    data: GetApiLocationGetByIdData,
  ): CancelablePromise<GetApiLocationGetByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/location/get/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns UserLocationDto Success
   * @throws ApiError
   */
  public static getApiLocation(): CancelablePromise<GetApiLocationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/location/",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiLocationUpdate(
    data: PostApiLocationUpdateData,
  ): CancelablePromise<PostApiLocationUpdateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/location/update",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class IssueService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns IssueNoteDto Success
   * @throws ApiError
   */
  public static postApiIssueComment(
    data: PostApiIssueCommentData,
  ): CancelablePromise<PostApiIssueCommentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/comment",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiIssueCreate(
    data: PostApiIssueCreateData,
  ): CancelablePromise<PostApiIssueCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmptyResponse Success
   * @throws ApiError
   */
  public static postApiIssueDeleteAttachment(
    data: PostApiIssueDeleteAttachmentData,
  ): CancelablePromise<PostApiIssueDeleteAttachmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/delete-attachment",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns IssueDto Success
   * @throws ApiError
   */
  public static postApiIssueGet(
    data: PostApiIssueGetData,
  ): CancelablePromise<PostApiIssueGetResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/get",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PagedResultOfIssueDto Success
   * @throws ApiError
   */
  public static postApiIssueList(
    data: PostApiIssueListData,
  ): CancelablePromise<PostApiIssueListResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/list",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PagedResultOfIssueDto Success
   * @throws ApiError
   */
  public static postApiIssueListAll(
    data: PostApiIssueListAllData,
  ): CancelablePromise<PostApiIssueListAllResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/list-all",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns PreUploadedFileDto Success
   * @throws ApiError
   */
  public static postApiIssuePreUploadAttachment(): CancelablePromise<PostApiIssuePreUploadAttachmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/pre-upload-attachment",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiIssueSendEmail(
    data: PostApiIssueSendEmailData,
  ): CancelablePromise<PostApiIssueSendEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/send-email",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns IssueNoteDto Success
   * @throws ApiError
   */
  public static postApiIssueAccepted(
    data: PostApiIssueAcceptedData,
  ): CancelablePromise<PostApiIssueAcceptedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/accepted",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiIssueSetCategory(
    data: PostApiIssueSetCategoryData,
  ): CancelablePromise<PostApiIssueSetCategoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/set-category",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiIssueSeen(
    data: PostApiIssueSeenData,
  ): CancelablePromise<PostApiIssueSeenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/seen",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.issueId
   * @returns IssueAttachmentDto Success
   * @throws ApiError
   */
  public static postApiIssueUploadAttachment(
    data: PostApiIssueUploadAttachmentData,
  ): CancelablePromise<PostApiIssueUploadAttachmentResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue/upload-attachment",
      headers: {
        issueId: data.issueId,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class IssueCategoriesService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns IssueCategoryDto Success
   * @throws ApiError
   */
  public static postApiIssueCategoriesCreate(
    data: PostApiIssueCategoriesCreateData,
  ): CancelablePromise<PostApiIssueCategoriesCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/issue-categories/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Success
   * @throws ApiError
   */
  public static deleteApiIssueCategoriesDeleteById(
    data: DeleteApiIssueCategoriesDeleteByIdData,
  ): CancelablePromise<DeleteApiIssueCategoriesDeleteByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/issue-categories/delete/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @returns IssueCategoryDto Success
   * @throws ApiError
   */
  public static getApiIssueCategoriesList(): CancelablePromise<GetApiIssueCategoriesListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/issue-categories/list",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns IssueCategoryDto Success
   * @throws ApiError
   */
  public static putApiIssueCategoriesUpdate(
    data: PutApiIssueCategoriesUpdateData,
  ): CancelablePromise<PutApiIssueCategoriesUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/issue-categories/update",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }
}

export class EmailContactsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailContactDto Success
   * @throws ApiError
   */
  public static postApiEmailContactsCreate(
    data: PostApiEmailContactsCreateData,
  ): CancelablePromise<PostApiEmailContactsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/email-contacts/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Success
   * @throws ApiError
   */
  public static deleteApiEmailContactsDeleteById(
    data: DeleteApiEmailContactsDeleteByIdData,
  ): CancelablePromise<DeleteApiEmailContactsDeleteByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/email-contacts/delete/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @returns EmailContactDto Success
   * @throws ApiError
   */
  public static getApiEmailContactsList(): CancelablePromise<GetApiEmailContactsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/email-contacts/list",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailContactDto Success
   * @throws ApiError
   */
  public static putApiEmailContactsUpdate(
    data: PutApiEmailContactsUpdateData,
  ): CancelablePromise<PutApiEmailContactsUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/email-contacts/update",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }
}

export class DocumentsService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns EmptyResponse Success
   * @throws ApiError
   */
  public static deleteApiDocumentsById(
    data: DeleteApiDocumentsByIdData,
  ): CancelablePromise<DeleteApiDocumentsByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/documents/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Success
   * @throws ApiError
   */
  public static getApiDocumentsDownload(
    data: GetApiDocumentsDownloadData,
  ): CancelablePromise<GetApiDocumentsDownloadResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/documents/download",
      query: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getApiDocumentsFolders(): CancelablePromise<GetApiDocumentsFoldersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/documents/folders",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DocumentsAndFolders Success
   * @throws ApiError
   */
  public static getApiDocumentsList(
    data: GetApiDocumentsListData = {},
  ): CancelablePromise<GetApiDocumentsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/documents/list",
      query: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.folder
   * @returns EmptyResponse Success
   * @throws ApiError
   */
  public static getApiDocumentsMove(
    data: GetApiDocumentsMoveData,
  ): CancelablePromise<GetApiDocumentsMoveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/documents/move",
      query: {
        id: data.id,
        folder: data.folder,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.folder
   * @returns string Success
   * @throws ApiError
   */
  public static postApiDocumentsUpload(
    data: PostApiDocumentsUploadData,
  ): CancelablePromise<PostApiDocumentsUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/documents/upload",
      headers: {
        folder: data.folder,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Success
   * @throws ApiError
   */
  public static getApiDocumentsView(
    data: GetApiDocumentsViewData,
  ): CancelablePromise<GetApiDocumentsViewResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/documents/view",
      query: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class TestService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiTestEmailall(
    data: PostApiTestEmailallData,
  ): CancelablePromise<PostApiTestEmailallResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/test/emailall",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiTestEmailtenant(
    data: PostApiTestEmailtenantData,
  ): CancelablePromise<PostApiTestEmailtenantResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/test/emailtenant",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiTestQuery(
    data: PostApiTestQueryData,
  ): CancelablePromise<PostApiTestQueryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/test/query",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiTestEmail(
    data: PostApiTestEmailData,
  ): CancelablePromise<PostApiTestEmailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/test/email",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
        403: "Forbidden",
      },
    });
  }
}

export class DeviceService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string Success
   * @throws ApiError
   */
  public static postApiDeviceCreate(
    data: PostApiDeviceCreateData,
  ): CancelablePromise<PostApiDeviceCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/device/create",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns EmptyResponse Success
   * @throws ApiError
   */
  public static deleteApiDeviceDeleteById(
    data: DeleteApiDeviceDeleteByIdData,
  ): CancelablePromise<DeleteApiDeviceDeleteByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/device/delete/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeviceDto Success
   * @throws ApiError
   */
  public static getApiDeviceById(
    data: GetApiDeviceByIdData,
  ): CancelablePromise<GetApiDeviceByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/device/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeviceDto Success
   * @throws ApiError
   */
  public static postApiDeviceList(
    data: PostApiDeviceListData,
  ): CancelablePromise<PostApiDeviceListResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/device/list",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string Success
   * @throws ApiError
   */
  public static postApiDevice(
    data: PostApiDeviceData,
  ): CancelablePromise<PostApiDeviceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/device",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class DashboardService {
  /**
   * @param data The data for the request.
   * @param data.from
   * @param data.to
   * @returns ComplianceStatDto Success
   * @throws ApiError
   */
  public static getApiDashboard(
    data: GetApiDashboardData,
  ): CancelablePromise<GetApiDashboardResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/dashboard",
      query: {
        from: data.from,
        to: data.to,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LocationComplianceStatDto Success
   * @throws ApiError
   */
  public static postApiDashboardLocation(
    data: PostApiDashboardLocationData,
  ): CancelablePromise<PostApiDashboardLocationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/dashboard/location",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class CompletedchecksService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CompletedCheckDto Success
   * @throws ApiError
   */
  public static getApiCompletedchecksById(
    data: GetApiCompletedchecksByIdData,
  ): CancelablePromise<GetApiCompletedchecksByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/completedchecks/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.from
   * @param data.to
   * @returns DailyReport Success
   * @throws ApiError
   */
  public static getApiCompletedchecksBydate(
    data: GetApiCompletedchecksBydateData,
  ): CancelablePromise<GetApiCompletedchecksBydateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/completedchecks/bydate",
      query: {
        from: data.from,
        to: data.to,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PagedResultOfCompletedCheckDto Success
   * @throws ApiError
   */
  public static postApiCompletedchecksListAll(
    data: PostApiCompletedchecksListAllData,
  ): CancelablePromise<PostApiCompletedchecksListAllResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/completedchecks/list-all",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiCompletedchecksSave(
    data: PostApiCompletedchecksSaveData,
  ): CancelablePromise<PostApiCompletedchecksSaveResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/completedchecks/save",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Success
   * @throws ApiError
   */
  public static postApiCompletedchecksSaveretroactive(
    data: PostApiCompletedchecksSaveretroactiveData,
  ): CancelablePromise<PostApiCompletedchecksSaveretroactiveResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/completedchecks/saveretroactive",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class CompletedChecksService {
  /**
   * @param data The data for the request.
   * @param data.key
   * @returns unknown Success
   * @throws ApiError
   */
  public static getApiCompletedChecksImage(
    data: GetApiCompletedChecksImageData,
  ): CancelablePromise<GetApiCompletedChecksImageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/completed-checks/image",
      query: {
        key: data.key,
      },
    });
  }
}

export class TasksService {
  /**
   * @param data The data for the request.
   * @param data.checkId
   * @param data.id
   * @returns CheckTaskDto2 Success
   * @throws ApiError
   */
  public static getApiTasksListByCheckId(
    data: GetApiTasksListByCheckIdData,
  ): CancelablePromise<GetApiTasksListByCheckIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tasks/list/{checkId}",
      path: {
        checkId: data.checkId,
      },
      query: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class CheckService {
  /**
   * @param data The data for the request.
   * @param data.from
   * @param data.to
   * @returns CalendarCheckDto Success
   * @throws ApiError
   */
  public static getApiCheckCalendar(
    data: GetApiCheckCalendarData,
  ): CancelablePromise<GetApiCheckCalendarResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/check/calendar",
      query: {
        from: data.from,
        to: data.to,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string Success
   * @throws ApiError
   */
  public static postApiCheckClone(
    data: PostApiCheckCloneData,
  ): CancelablePromise<PostApiCheckCloneResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/check/clone",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string Success
   * @throws ApiError
   */
  public static putApiCheck(
    data: PutApiCheckData,
  ): CancelablePromise<PutApiCheckResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/check",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string Success
   * @throws ApiError
   */
  public static postApiCheck(
    data: PostApiCheckData,
  ): CancelablePromise<PostApiCheckResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/check",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteApiCheckById(
    data: DeleteApiCheckByIdData,
  ): CancelablePromise<DeleteApiCheckByIdResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/check/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CheckDto Success
   * @throws ApiError
   */
  public static getApiCheckById(
    data: GetApiCheckByIdData,
  ): CancelablePromise<GetApiCheckByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/check/{id}",
      path: {
        id: data.id,
      },
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns ExportCheckDto Success
   * @throws ApiError
   */
  public static getApiCheckExport(): CancelablePromise<GetApiCheckExportResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/check/export",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiCheckImport(
    data: PutApiCheckImportData,
  ): CancelablePromise<PutApiCheckImportResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/check/import",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PagedResultOfListCheckDto Success
   * @throws ApiError
   */
  public static postApiCheckList(
    data: PostApiCheckListData,
  ): CancelablePromise<PostApiCheckListResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/check/list",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @returns TodayCheckDto Success
   * @throws ApiError
   */
  public static getApiCheckListTodays(): CancelablePromise<GetApiCheckListTodaysResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/check/list-todays",
      errors: {
        401: "Unauthorized",
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean Success
   * @throws ApiError
   */
  public static postApiCheckOrder(
    data: PostApiCheckOrderData,
  ): CancelablePromise<PostApiCheckOrderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/check/order",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}

export class ChatbaseService {
  /**
   * @returns TokenJson Success
   * @throws ApiError
   */
  public static getApiChatbase(): CancelablePromise<GetApiChatbaseResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/chatbase",
      errors: {
        401: "Unauthorized",
      },
    });
  }
}
